var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuniperCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D0D8BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8445 6.99812c.1824.15078.2081.42092.0573.60337l-7.4657 9.03431-.001.0012c-.1223.1468-.2758.2646-.44923.3446-.17348.0801-.36262.1205-.55367.1183h-.00038c-.19417-.0024-.38528-.0488-.55897-.1357-.17331-.0866-.32479-.2113-.44312-.3648-.00025-.0003-.00051-.0006-.00076-.0009L6.0903 13.5916c-.14532-.1868-.11166-.4561.07517-.6014.18684-.1453.4561-.1117.60141.0752l2.34134 3.0103c.03948.0513.09006.0929.14796.1219.05781.0289.12141.0444.18604.0452.06365.0007.12666-.0127.18446-.0394.05761-.0266.1086-.0657.14929-.1144.00014-.0001.00029-.0003.00044-.0005l7.46469-9.03302c.1508-.18246.4209-.20814.6034-.05736Z",
    fill: "#133F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniperCircleTick);
export default __webpack_public_path__ + "static/media/juniper-circle-tick.572517fba26e560d0c30debdf9c0e070.svg";
export { ForwardRef as ReactComponent };